import React from 'react';
import { FlaskConical } from 'lucide-react';
import '../styles/ProvenanceBadge.css';

// ProvenanceBadge — the ONE shared illustrative-provenance chip (029-value-proven-
// dashboard, FR-002, SC-001). The load-bearing safety mechanism: every figure
// sourced from the labelled illustrative fixture wears this so a viewer can tell
// sample from measured AT A GLANCE.
//
// Honesty contract:
//   • Carries the LITERAL word "Illustrative" as VISIBLE TEXT — never colour
//     alone. The flask glyph is decorative (aria-hidden); the text + the
//     accessible name "Illustrative sample data" carry the meaning.
//   • NEUTRAL styling only (index.css tokens — faint text + slate border, a
//     hatched/dashed chip). It NEVER spends the reserved coral (--ap-accent) and
//     opts into NO data-reserved-colour.
//
// Minimal prop shape: `source` defaults to 'illustrative' (the only source the
// badge represents today), so <ProvenanceBadge /> and
// <ProvenanceBadge source="illustrative" /> render identically.
const ProvenanceBadge: React.FC<{ source?: 'illustrative' }> = () => (
  <span className="ap-provenance-badge" aria-label="Illustrative sample data">
    <FlaskConical className="ap-provenance-badge-icon" size={12} aria-hidden="true" />
    <span aria-hidden="true">Illustrative</span>
  </span>
);

export default ProvenanceBadge;
